import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatdatetimestamp'
})
export class FormatdatetimestampPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if ((value === null) || (value === '')) {
      return null;
    } else {
      return moment(new Date(value * 1000)).format('DD/MM/YYYY HH:mm');
    }
  }

}
